import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import AppService from '@/lib/App';

/**
 * Fetches the list of tech families enrolled in the canary rollout pilot.
 * The result is cached for 5 minutes (staleTime) since this list changes
 * infrequently (UCM-backed).
 */
export function useGetCanaryPilotTechFamilies(options?: {
  [key: string]: any;
}) {
  return useQueryWithLogging({
    queryKey: ['canaryPilotTechFamilies'],
    queryFn: () => AppService.planner.getCanaryPilotTechFamilies(),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
